export enum PASSWORD_RULES {
    AllowedCharacters = "allowed characters",
    CharactersLength = "characters length",
    PasswordsMustMatch = "passwords must match"
}
